import { createSelector } from '@reduxjs/toolkit';
import { initialState } from '../Slice/FilterSlice';
import { RootState } from '../Store/InjectorsTypes';

const selectDomain = (state: RootState) => state?.filter || initialState;

export const selectCompanyFilters = createSelector(
  [selectDomain],
  (state) => state.companyFilters,
);
export const selectArticleFilters = createSelector(
  [selectDomain],
  (state) => state.articleFilters,
);
export const selectSearchDistinctFilters = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter,
);

export const selectDistinctCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.companyLoading,
);

export const selectDistinctCompany = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter.companies,
);

export const selectDistinctCompanyCount = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter.companiesCount,
);

export const selectDistinctCompanyPage = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter.companyPage,
);

export const selectDistinctDesignationLoading = createSelector(
  [selectDomain],
  (state) => state.designationLoading,
);

export const selectDistinctDesignation = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter.designations,
);

export const selectDistinctDesignationCount = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter.designationsCount,
);

export const selectDistinctDesignationPage = createSelector(
  [selectDomain],
  (state) => state.distinctsFilter.designationPage,
);

export const selectDistinctDesignationSearchTerm = createSelector(
  [selectDomain],
  (state) => state.designationSearchTerm,
);

export const selectDistinctCompanySearchTerm = createSelector(
  [selectDomain],
  (state) => state.companySearchTerm,
);
// advanced search selectors
export const selectAdvancedDistinctCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.advCompanyLoading,
);

export const selectAdvancedDistinctCompany = createSelector(
  [selectDomain],
  (state) => state.advDistinctsFilter.companies,
);

export const selectAdvancedDistinctCompanyCount = createSelector(
  [selectDomain],
  (state) => state.advDistinctsFilter.companiesCount,
);

export const selectAdvancedDistinctCompanyPage = createSelector(
  [selectDomain],
  (state) => state.advDistinctsFilter.companyPage,
);

export const selectAdvancedDistinctDesignationLoading = createSelector(
  [selectDomain],
  (state) => state.advDesignationLoading,
);

export const selectAdvancedDistinctDesignation = createSelector(
  [selectDomain],
  (state) => state.advDistinctsFilter.designations,
);

export const selectAdvancedDistinctDesignationCount = createSelector(
  [selectDomain],
  (state) => state.advDistinctsFilter.designationsCount,
);

export const selectAdvancedDistinctDesignationPage = createSelector(
  [selectDomain],
  (state) => state.advDistinctsFilter.designationPage,
);

export const selectAdvancedDistinctDesignationSearchTerm = createSelector(
  [selectDomain],
  (state) => state.advDesignationSearchTerm,
);

export const selectAdvancedDistinctCompanySearchTerm = createSelector(
  [selectDomain],
  (state) => state.advCompanySearchTerm,
);
// similar people
export const selectSimilarDistinctCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.similarCompanyLoading,
);

export const selectSimilarDistinctCompany = createSelector(
  [selectDomain],
  (state) => state.similarDistinctsFilter.companies,
);

export const selectSimilarDistinctCompanyCount = createSelector(
  [selectDomain],
  (state) => state.similarDistinctsFilter.companiesCount,
);

export const selectSimilarDistinctCompanyPage = createSelector(
  [selectDomain],
  (state) => state.similarDistinctsFilter.companyPage,
);

export const selectSimilarDistinctDesignationLoading = createSelector(
  [selectDomain],
  (state) => state.similarDesignationLoading,
);

export const selectSimilarDistinctDesignation = createSelector(
  [selectDomain],
  (state) => state.similarDistinctsFilter.designations,
);

export const selectSimilarDistinctDesignationCount = createSelector(
  [selectDomain],
  (state) => state.similarDistinctsFilter.designationsCount,
);

export const selectSimilarDistinctDesignationPage = createSelector(
  [selectDomain],
  (state) => state.similarDistinctsFilter.designationPage,
);

export const selectSimilarDistinctDesignationSearchTerm = createSelector(
  [selectDomain],
  (state) => state.similarDesignationSearchTerm,
);

export const selectSimilarDistinctCompanySearchTerm = createSelector(
  [selectDomain],
  (state) => state.similarCompanySearchTerm,
);
// followed people
export const selectFollowedDistinctCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.followCompanyLoading,
);

export const selectFollowedDistinctCompany = createSelector(
  [selectDomain],
  (state) => state.followDistinctsFilter.companies,
);

export const selectFollowedDistinctCompanyCount = createSelector(
  [selectDomain],
  (state) => state.followDistinctsFilter.companiesCount,
);

export const selectFollowedDistinctCompanyPage = createSelector(
  [selectDomain],
  (state) => state.followDistinctsFilter.companyPage,
);

export const selectFollowedDistinctDesignationLoading = createSelector(
  [selectDomain],
  (state) => state.followDesignationLoading,
);

export const selectFollowedDistinctDesignation = createSelector(
  [selectDomain],
  (state) => state.followDistinctsFilter.designations,
);

export const selectFollowedDistinctDesignationCount = createSelector(
  [selectDomain],
  (state) => state.followDistinctsFilter.designationsCount,
);

export const selectFollowedDistinctDesignationPage = createSelector(
  [selectDomain],
  (state) => state.followDistinctsFilter.designationPage,
);

export const selectFollowedDistinctDesignationSearchTerm = createSelector(
  [selectDomain],
  (state) => state.followDesignationSearchTerm,
);

export const selectFollowedDistinctCompanySearchTerm = createSelector(
  [selectDomain],
  (state) => state.followCompanySearchTerm,
); 
